
import { useRouter, useRoute } from "vue-router";
import { reactive, ref, inject, shallowRef } from "vue";
import Card from "@/components/card/card.vue";
import Headline from "@/components/headline/headline.vue";
import IconDesign from "@/components/icon-design/icon-design.vue";
import Tabbar from "@/components/tabbar/index.vue";
import Banner from "@/components/home/banner.vue";
import { Toast } from "vant";
import { getShowAfter } from '@/hooks/afterSale'

export default {
  components: {
    Card,
    Headline,
    IconDesign,
    Tabbar,
    Banner,
  },
  setup() {
    const $http: any = inject("$http");
    const $store: any = inject("$store");
    const router = useRouter();
    const route = useRoute();
    const tabbar_index = ref(4);
    let loginSate = ref(false),
      userData: any = reactive({}),
      advertisingSwiper = shallowRef([]),
      currencyUnit: String = $store.getSymbol(), //货币单位
      attribute: any = ref([
        {
          title: "My Wishlist",
          amount: 0,
          url: "favoriteGoods",
        },
        {
          title: "Followed Store",
          amount: 0,
          url: "SavedShops",
        },
      ]),
      myAssets: any = ref([
        {
          title: "Balance",
          amount: 0,
          url: "wallet",
        },
        {
          title: "Vouchers",
          amount: 0,
          url: "myVouchers",
        },
        {
          title: "Coins",
          amount: 0,
          url: `coinRewards`,
        },
      ]),
      moneyValue = ref(false),
      historyList: any = shallowRef([]);

    const IconMyOrders = reactive([
      {
        imgsUrl: "paid",
        title: "Unpaid",
        data: "/order?name=state_new",
        type: "url",
      },
      {
        imgsUrl: "point-gift-o",
        title: "To be Shipped",
        data: "/order?name=state_paid",
        type: "url",
      },
      {
        imgsUrl: "logistics",
        title: "Shipped",
        data: "/order?name=state_trasit",
        type: "url",
      },
      {
        imgsUrl: "goods-collect-o",
        title: "To be Reviewed",
        data: "/order",
        type: "url",
      },
      
    ]);
    
    const IconMyTools = reactive([
      {
        imgsUrl: "location-o",
        title: "Address Book",
        data: "/address-list",
        type: "url",
      },
      {
        imgsUrl: "setting-o",
        type: "url",
        title: "Settings",
        data: "/setting",
      },
      {
        imgsUrl: "underway-o",
        type: "url",
        title: "History   View",
        data: "/HistoryView",
      },
       {
        imgsUrl: "question-o",
        type: "url",
        title: "Frequent Asked Questions",
        data: "/help",
      },
    ]);

    let IconMyOrdersLinefew =ref(4) 

    /**
     * 当前页面form表单提交post数据，跳转lipapay收银台
     * 禁止iframe。safari安全策略问题。
     */
    const open = (verb: any, url: any, data: any) => {
      var form = document.createElement("form");
      form.action = url;
      form.method = verb;
      form.target = "_self";
      if (data) {
        for (var key in data) {
          var input = document.createElement("input");
          input.name = key;
          input.value =
            typeof data[key] === "object"
              ? JSON.stringify(data[key])
              : data[key];
          form.appendChild(input);
        }
      }
      form.style.display = "none";
      document.body.appendChild(form);
      form.submit();
    };
    if (common.getStorage("user_info")) {
      userData = common.getStorage("user_info");
      loginSate.value = true;
      let parms = {
        size: 100,
        page: 1,
      };
      $http.get_favorite_list(parms).then((res: any) => {
        if (res.code === 200) {
          attribute.value[0].amount = res.data.length;
          res.data.forEach((item: any) => {
            item.goods_id = item.goods && item.goods.goods_id;
            item.goods_image_url = item.goods && item.goods.image;
            item.name = item.goods && item.goods.title;
            item.promotion_price = item.goods && item.goods.price;
            item.marketprice = item.goods && item.goods.price_market;
          });
          $store.setWishList(res.data);
        }
      });
      $http.get_store_favorite_list(parms).then((res: any) => {
        if (res.code === 200) {
          attribute.value[1].amount = res.data.length;
        }
      });
      //钱包
      $http.get_walletInfo({}).then((res: any) => {
        if (res.code === 200) {
          myAssets.value[0].amount = res.data.balance;
        }
      });
      //优惠券列表
      $http
        .get_voucher_list({ ...parms, voucher_state: 1 })
        .then((res: any) => {
          console.log(res);
          if (res.code === 200) {
            myAssets.value[1].amount = res.data.length;
          }
        });
      //奖励列表
      // $http.get_coins_list({
      //   ...parms,
      //   use_type:0
      // }).then((res: any) => {
      //   if(res.code === 200){
      //     myAssets.value[2].amount = res.data.length
      //   }
      // });
      // 用户积分
      let post_Feedbacks_Cash_Rewards_fn = async () => {
        let ret = await $http.post_Feedbacks_Cash_Rewards();
        if (ret.code === 200) {
          myAssets.value[2].amount = ret.data.total;
          myAssets.value[2].url = `coinRewards?coins_total=${ret.data.total}`;
        }
      };
      post_Feedbacks_Cash_Rewards_fn();
    }
    //广告位
    $http.get_advertisement({ code: "memberIndex" }).then((res: any) => {
      console.log("res", res);
      if (res.code === 200 && res != null) {
        advertisingSwiper.value = res.data;
      }
    });

    //钱包跳转
    const get_walletPage_fn = async () => {
      let res = await $http.get_walletPage({});
      if (res.code === 200) {
        open("POST", res.data.url, res.data.data);
      }
    };
    const is_act_wallet_view = ref(false)
    //路由跳转
    const jump_func = (url: string) => {
      if (loginSate.value) {
        if (url === "wallet") {
          // if(!userData.phone) {
          //   router.push('/modify-email?type=phone&is_wallet=1')
          //   return
          // }
          get_walletPage_fn();
        } else {
          router.push("/" + url);
        }
      } else {
        Toast("Please log in");
        router.push("/login");
      }
    };
    if(route.query.act_wallet_view === '1' ) {
      is_act_wallet_view.value = true
      jump_func('wallet');
    }
    //控制钱显示隐藏
    let control_btns = () => {
      moneyValue.value = !moneyValue.value;
    };
    getShowAfter().then((res:any)=>{
        console.log('after权限',res);
        if(res.code === 200){
          const permission = res.data
           if(permission.new_aftersale_isuse){
             ++IconMyOrdersLinefew.value 
            //  new_aftersale_isuse 为1表示售后开关开启,反之则是关闭的
             IconMyOrders.push({
                      imgsUrl: "tosend",
                      title: "Return/Refund",
                      data: "/afterSale?name=state_apply",
                      type: "url",
                    }) 
           }
            
        }
        
    })

    return {
      IconMyOrders,
      IconMyTools,
      tabbar_index,
      userData,
      loginSate,
      advertisingSwiper,
      attribute,
      jump_func,
      myAssets,
      control_btns,
      moneyValue,
      currencyUnit,
      IconMyOrdersLinefew,
      is_act_wallet_view
    };
  },
};
